import * as constants from '../constants';

const INITIAL_STATE = {
    values: {},
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case constants.PROPERTY_VALUE_UPDATE:
            return Object.assign({}, state, {values: Object.assign({}, state.values, {
                [`${action.payload.nodeId}/${action.payload.propertyId}`]: action.payload.value,
            })});
    }
    return state;
}
